@if(display()) {
  <ion-item lines="full" routerLink="/inventory/beer/details/{{ beverage?.id }}">
    @if (beverage?.image) {
      <ion-thumbnail slot="end">
        <img [src]="beverage?.image" />
      </ion-thumbnail>
    }
    <!-- <ion-thumbnail slot="end">
    <img src="/assets/icons/flat/beer/cans/beer-can.svg" />
  </ion-thumbnail> -->

  <ion-label>
    {{ beverage?.name }}
    <div class="ps-badge-list">
      <ion-badge>
        Bottles: {{ bottle?.count }}
      </ion-badge>
      <ion-badge>
        Size: {{ bottle?.size }}
      </ion-badge>
      @if (bottle?.notificationDate) {
<ion-badge [color]="{
          'danger': dateHelper.lessThanOrEqualTo(
            bottle?.notificationDate,
            today
          )
        }">
          <ion-icon name="notifications-outline"></ion-icon>
          Notification:
          {{ dateHelper.calendar(bottle?.notificationDate) }}
        </ion-badge>
      }
      @if (bottle?.bestBeforeDate) {
<ion-badge [color]="{
          'danger': dateHelper.lessThanOrEqualTo(
            bottle?.bestBeforeDate,
            today
          )
        }">
          <ion-icon name="calendar-clear-outline"></ion-icon>
          BBF:
          {{
          dateHelper.formatDate(bottle?.bestBeforeDate, "MMMM yyyy")
          }}
        </ion-badge>
      }
    </div>
  </ion-label>
</ion-item>
}